import * as React from 'react'
import { Outlet, useParams } from 'react-router-dom'

import { UniversalImporterEmployeesPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const UniversalImporterEmployeesPage = () => {
  const { company, access } = useCurrentSession()
  const { legal_entity_id: legalEntityId } = useParams<{ legal_entity_id?: string }>()
  const { data, loading, error } = useQuery(UniversalImporterEmployeesPageDocument, {
    variables: { legalEntityId: String(legalEntityId) },
    fetchPolicy: 'network-only',
    skip: !legalEntityId,
  })

  const canImportResources = data?.universalImporter._policies.importResources.can

  const authorized = canImportResources
  const locale = access.locale
  const legalEntityCountry = data?.companies.legalEntitiesConnection.nodes[0]?.country
  const metadata = {
    legal_entity_ids: legalEntityId ? [BigInt(legalEntityId)] : [],
    legal_entity_countries: legalEntityCountry ? [legalEntityCountry] : [],
  }

  return (
    <ResponsivePage.Body
      authorized={authorized}
      loading={loading}
      error={!legalEntityId || error}
      showHeader={false}
    >
      <NuvoImporter
        importType="employee_importer"
        locale={locale}
        companyId={company.id}
        metadata={metadata}
      />
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default UniversalImporterEmployeesPage
